import axios from 'axios'

const baseURLs = {
  'mt.solar-grids.com': 'https://api-gw.dev.aikoenergy.com',
  'cname-mt.solar-grids.com': 'https://api-gw.dev.aikoenergy.com',
  'som.dev.aikoenergy.com': 'https://api-gw.dev.aikoenergy.com',
  'som.int.aikoenergy.com': 'https://som.int.aikoenergy.com',
  'cn.som.aikoenergy.com': 'https://api-gw.aikoenergy.com',
  'emp.solar-grids.com': 'https://api-gw.aikoenergy.com',
  localhost: 'https://api-gw.dev.aikoenergy.com', // 本地开发环境
  '10.8.23.64': 'https://api-gw.dev.aikoenergy.com',
  '10.8.19.249': 'https://api-gw.dev.aikoenergy.com'
  // 可以继续添加其他域名映射
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: baseURLs[window.location.hostname] || '/', // 所有的请求地址前缀部分
  timeout: 60000, // 请求超时时间毫秒
  withCredentials: false, // 异步请求携带cookie
  headers: {
    // 设置后端需要的传参类型
    // 'Content-Type': 'application/json',
    // 'token': 'your token',
    // 'X-Requested-With': 'XMLHttpRequest',
  }
})

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // console.log('request-请求数据', config.Authorization)
    config.displayErrorMessage =
      config.displayErrorMessage === undefined
        ? true
        : config.displayErrorMessage
    config.Authorization =
      config.Authorization === undefined ? true : config.Authorization
    config.headers['cache-control'] = 'no-cache'
    if (config.params) {
      config.params._t = +new Date()
    } else {
      config.params = {
        _t: +new Date()
      }
    }
    // 在发送请求之前做些什么
    return config
  },
  function (error) {
    // 对请求错误做些什么
    console.log('request-error', error)
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    // console.log('response', response)
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    // 这个状态码是和后端约定的
    const code = dataAxios.errorCode
    // 文件流传输特殊处理
    let dis = response.headers['content-disposition']
    let fileName = ''
    if (dis) {
      let fileNames = dis.split('attachment;filename=')[1]
      if (fileNames) fileName = decodeURIComponent(fileNames)
    }

    return response
  },
  async function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

export default service
